import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'default', pure: false})
export class DefaultPipe implements PipeTransform {
    transform(value: any, defaultValue = null, int = false): any {
        return value ? (int ? parseInt(value) : value) : defaultValue;
    }
}
